export default "__VITE_ASSET__CgJz5kfk__"